import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';
import {legacyPermissionsEnabled} from '@netx/core-permissions-next/enablers/legacyPermissionsEnabled';
import {getUserLevel} from '@netx/core-user-next/utils/getUserLevel';
import {getViewModel} from '@netx/core/lib/utils';

// TODO: this is a util, not a property file

/**
 * @function
 * @param {array} actions Actions
 * @param {module:core/lib/netx-view} view View instance
 * @return {array} Enabled actions
 */
export const getEnabledActions = (actions, view) => {
	// if (currentUserIsAdmin()) return actions;

	const userLevel = getUserLevel();
	const usingLegacyPermissions = legacyPermissionsEnabled();

	return actions.filter((action) => {
		if (!action) return false;
		const actionUserLevel = action.userLevel;
		const model = getViewModel(view);

		// User level
		// Leaving this check here for `userLevel < 9` - not sure why we would have any
		// actions with user levels greater than 9 but ¯\_(ツ)_/¯
		// Bypassing check when not using legacy permissions
		if (
			usingLegacyPermissions &&
			actionUserLevel &&
			userLevel < 9 &&
			!currentUserIsAdmin() &&
			userLevel < actionUserLevel
		) {
			return false;
		}

		// Action matrix
		const actionMatrix = action.matrix;
		if (actionMatrix && usingLegacyPermissions && model) {
			const modelAllows = model.allows;
			// check for fuxxups in action config:
			if (typeof modelAllows !== 'function') {
				console.warn(
					'action "' +
						action.event +
						'" defined "matrix", but no allows() method was found on model.',
				);
			} else if (!modelAllows.call(model, actionMatrix)) return false;
		}

		// Enable test(s)
		const actionEnableTest = action.enableTest;
		if (typeof actionEnableTest === 'function') {
			if (!actionEnableTest(view)) return false;
		} else if (_.isArray(actionEnableTest)) {
			const failedEnableTest = actionEnableTest.some((enableTest) => {
				if (!enableTest) return;
				if (typeof enableTest !== 'function') {
					throw new Error(
						`enableTest array contained non-function: ${enableTest}`,
					);
				}
				return !enableTest(view);
			});
			if (failedEnableTest) return false;
		}

		return true;
	});
};
